import { LotterySchema, RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { LotteryResponseSchema } from './common';

export type GetLotteryParams = Static<typeof GetLotteryParamsSchema>;
export const GetLotteryParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'GetLotteryParamsSchema' }
);

export type GetLotteryResponse = Static<typeof GetLotteryResponseSchema>;
export const GetLotteryResponseSchema = Type.Object(
  {
    lottery: LotteryResponseSchema,
  },
  { additionalProperties: false, $id: 'GetLotteryResponseSchema' }
);
